import {createReducer} from '@reduxjs/toolkit';
import isEqual from 'lodash/isEqual';

import {loadSearch as loadSavedSearch} from '@src/actions/search';
import * as searchFilterActions from '@src/actions/search-filters';
import {
  IMAGERY_CAPABILITIES,
  PSSCENE_IMAGERY_CAPABILITIES_ASSETS,
  SR_ASSETS,
} from '@src/constants/asset-types';
import {
  PS_INSTRUMENTS,
  PUBLISHING_STAGES_DEFAULT,
  findNestedObj,
} from '@src/utils/filters.js';

export const initialState = {
  accessPermissions: true,
  satelliteId: '',
  instruments: PS_INSTRUMENTS,
  publishingStages: PUBLISHING_STAGES_DEFAULT,
  selectedImageryCapabilities: [IMAGERY_CAPABILITIES.nir],
  sr: false,
};

const searchFilters = createReducer(initialState, builder => {
  builder.addCase(searchFilterActions.setSearchFilters, (state, {payload}) => ({
    ...state,
    ...payload,
  }));

  builder.addCase(
    searchFilterActions.setAccessPermissions,
    (state, {payload}) => {
      state.accessPermissions = payload;
    },
  );

  builder.addCase(searchFilterActions.setSatelliteId, (state, {payload}) => {
    state.satelliteId = payload;
  });

  builder.addCase(searchFilterActions.setInstruments, (state, {payload}) => {
    state.instruments = payload;
  });

  builder.addCase(
    searchFilterActions.setPublishingStages,
    (state, {payload}) => {
      state.publishingStages = payload;
    },
  );

  builder.addCase(searchFilterActions.resetSearchFilters, () => initialState);

  builder.addCase(
    searchFilterActions.selectImageryCapabilities,
    (state, {payload: capabilities}) => {
      state.selectedImageryCapabilities = capabilities;
    },
  );

  builder.addCase(searchFilterActions.setSR, (state, {payload: sr}) => {
    state.sr = sr;
  });

  builder.addCase(loadSavedSearch, (state, {payload: search}) => {
    const permissionFilter = findNestedObj(
      search.filter,
      'type',
      'PermissionFilter',
    )[0];
    const satelliteIdFilter = findNestedObj(
      search.filter,
      'field_name',
      'satellite_id',
    )[0]?.config.toString();
    const instrumentFilter = findNestedObj(
      search.filter,
      'field_name',
      'instrument',
    )[0]?.config.reduce((acc, curr) => ((acc[curr] = true), acc), {});
    const publishingStageFilter = findNestedObj(
      search.filter,
      'field_name',
      'publishing_stage',
    )[0]?.config.reduce((acc, curr) => ((acc[curr] = true), acc), {});

    const assetFilters = findNestedObj(search.filter, 'type', 'AssetFilter');

    const SRFilter = !!assetFilters.find(filter =>
      isEqual(filter.config, SR_ASSETS),
    );

    const imageryCapsFilter = assetFilters.reduce((acc, curr) => {
      const key = Object.keys(PSSCENE_IMAGERY_CAPABILITIES_ASSETS).find(key =>
        // we can do includes because right now the values is just 1 string
        curr.config.includes(PSSCENE_IMAGERY_CAPABILITIES_ASSETS[key]),
      );
      if (key) {
        acc.push(key);
      }
      return acc;
    }, []);

    state.accessPermissions = !!permissionFilter;
    state.instruments = instrumentFilter ?? initialState.instruments;
    state.publishingStages =
      publishingStageFilter ?? initialState.publishingStages;

    (state.satelliteId = satelliteIdFilter ?? initialState.satelliteId),
      (state.selectedImageryCapabilities =
        imageryCapsFilter ?? initialState.selectedImageryCapabilities);
    state.sr = SRFilter ?? initialState.sr;
  });
});

export default searchFilters;
